import React,{useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import './foot.css';
import { useTranslation, Trans } from 'react-i18next'



const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        client_id:state.client_id,
        pass:state.pass
    }
}



const Foot = (props) => {
    const { t } = useTranslation()
    const location = useLocation()
    const {pathname , search} = location
    
   

    useEffect(() => {
       
      
        
        //console.log(lastMessage)
    }, 
    // eslint-disable-next-line 
    []);

    

    
        return (
            <>
            <div className="tabbar w-full h-12">
                <Link to="/" className={`${pathname==='/'?'tabBarItem2':'tabBarItem1'} w-1/4 mx-px`}>{t('foot.单币质押')}</Link>
                <Link to="/market"  className={`${pathname==='/market'?'tabBarItem2':'tabBarItem1'} w-1/4 mx-px`}>{t('foot.LDF行情')}</Link>
                <Link to="/mapping"  className={`${pathname==='/mapping'?'tabBarItem2':'tabBarItem1'} w-1/4 mx-px`}>{t('foot.映射')}</Link>
                <Link to="/swap"  className={`${pathname==='/swap'?'tabBarItem2':'tabBarItem1'} w-1/4 mx-px`}>{t('foot.闪兑')}</Link>
                <Link to="/eco"  className={`${pathname==='/eco'?'tabBarItem2':'tabBarItem1'} w-1/4 mx-px`}>{t('foot.生态')}</Link>
                {/* <div  className={`${pathname==='/lp'?'tabBarItem2':'tabBarItem1'} w-1/5 mx-px`}>{t('foot.流动性挖矿')}</div> */}
		    </div>
            
            </>
                
            
        );
    
    
}



export default connect(mapStateToProps)(Foot);
